export const PlaceData = [
    [
        { 
            name: "user_ad_personal_info.legal_entity_data.city", 
            label: "Город", 
            placeholder: "Москва", 
            type: "text",
        },
        { 
            name: "user_ad_personal_info.legal_entity_data.street", 
            label: "Улица", 
            placeholder: "Пушкина", 
            type: "text",
        },
        { 
            name: "user_ad_personal_info.legal_entity_data.house", 
            label: "Дом", 
            placeholder: "10", 
            type: "text"
        },
        { 
            name: "user_ad_personal_info.legal_entity_data.appartment_number", 
            label: "Квартира", 
            placeholder: "95",
            type: "text",
            maskConfig: {
                mask: Number
            }
        },
        { 
            name: "user_ad_personal_info.legal_entity_data.index", 
            label: "Индекс", 
            placeholder: "440231", 
            type: "text",
            maskConfig: {
                mask: Number
            }
        },
    ],
];